const LoginRoutingPath = {
  loginForm: '/home/login',
  loginVerify: '/home/login/verifycode',
  dashboard: '/dashboard',
  forgotPasswordVerify: '/home/forgot-password/verifycode',
  forgotPasswordNewPassword: '/home/forgot-password/new-password',
  accountUpdated: '/home/forgot-password/success',
};

export default LoginRoutingPath;
